import { useCallback } from 'react';
export var useSwatch = function useSwatch(props) {
  var onClick = props.onClick,
      value_index = props.value_index;
  var handleClick = useCallback(function () {
    onClick(value_index);
  }, [value_index, onClick]);
  return {
    handleClick: handleClick
  };
};